export default __webpack_public_path__ + "static/banner-ecommerce-development-801829aec579970d503d06766849676b.jpg";